import React from "react";
import {
  Authenticator,
  ThemeProvider,
  useTheme,
  View,
} from '@aws-amplify/ui-react';
const AuthStyle = ({ AppRoutes }) => {
  const { tokens } = useTheme();
  const simulatorTheme = {
    name: 'Simulator Theme',
    tokens: {
      components: {
        authenticator: {
          router: {
            boxShadow: `0 0 16px ${tokens.colors.overlay['10']}`,
            borderWidth: '0',
          },
          form: {
            padding: `${tokens.space.medium} ${tokens.space.xl} ${tokens.space.medium}`,
          },
        },
        button: {
          primary: {
            backgroundColor: tokens.colors.teal['100'],
          },
          link: {
            color: tokens.colors.blue['90'],
          },
        },
        fieldcontrol: {
          _focus: {
            boxShadow: `0 0 0 2px ${tokens.colors.blue['60']}`,
          },
        },
        tabs: {
          item: {
            color: tokens.colors.teal['80'],
            _active: {
              borderColor: tokens.colors.teal['100'],
              color: tokens.colors.blue['100'],
            },
          },
        },
      },
    },
  };

  return (
    <ThemeProvider theme={simulatorTheme}>
      <View style={{
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        minHeight: '100vh',
        backgroundImage: 'linear-gradient(to top, #30cfd0 0%, #330867 100%)'
      }}>
        <Authenticator hideSignUp>
          {({ signOut, user }) => <AppRoutes user={user} />}
        </Authenticator>
      </View>
    </ThemeProvider >
  );
}

export default AuthStyle;